<template>
  <v-container id="carMargin">
    <div class="backLogoDiv">
      <img class="backLogo" :src="getCategoryBrand($store.getters.getCurrentCategory.brand)">
    </div>
    <v-layout row wrap align-center>
      <v-flex xs12 text-xs-center>
        <!-- CAROUSEL -->
        <carousel-3d
          id="selectorMain"
          controls-visible
          autoplay
          :controls-width="100"
          :clickable="false"
          perspective="0"
          inverse-scaling="0"
          space="150"
          width="800"
          height="450"
          border="0"
          @before-slide-change="currentIndexUpdate($event)"
          :controls-prev-html="'&#xE314;'" 
          :controls-next-html="'&#xE315;'"
          dir="ltr">
          <slide
            v-for="(video, i) in $store.getters.getCurrentCategory.videos"
            :index="i"
            :key="i"
            style="box-shadow: 0px 0px 20px 5px rgba(0, 0, 0, 0.5)">
            <!-- SLIDE -->
            <div id="carouselMain-img" :style="{ backgroundImage: `url('` + getVideo(video).imageUrl + `')`}">
              <v-container fill-height>
                <v-layout row wrap align-center>
                  <v-flex text-xs-center>
                    <v-icon id="playArrow" x-large @click="playVideo(video)">play_arrow</v-icon>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </slide>
        </carousel-3d>
      </v-flex>
      <!-- DESCRIPTION -->
      <v-container id="descriptSize">
        <v-flex xs12>
          <v-layout row wrap class="font-number">
            <v-flex xs8 text-xs-left>
              {{ getVideo($store.getters.getCurrentCategory.videos[cIndex]).name }}
            </v-flex>
            <v-flex xs2 text-xs-center>
              {{ getVideo($store.getters.getCurrentCategory.videos[cIndex]).views }}
            </v-flex>
            <v-flex xs2 text-xs-center>
              {{ getVideo($store.getters.getCurrentCategory.videos[cIndex]).likes }}
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout
            row
            wrap
            class="font-heading"
            :style="{'color': 'white'}">
            <v-flex xs8 text-xs-left>
              {{ getVideo($store.getters.getCurrentCategory.videos[cIndex]).duration }} min
            </v-flex>
            <v-flex xs2 text-xs-center>{{ $t("views") }}</v-flex>
            <v-flex xs2 text-xs-center>{{ $t("likes") }}</v-flex>
          </v-layout>
        </v-flex>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
export default {
  name: "Home",
  data() {
    return {
      cIndex: 0
    };
  },
  components: {
    Carousel3d,
    Slide
  },
  methods: {
    playVideo(videoId) {
      this.$store.dispatch("playVideo", { id: videoId });
    },
    currentIndexUpdate(payload) {
      this.cIndex = payload;
    },
    getVideo(id) {
      return this.$store.getters.getVideos.find(video => video.id === id);
    },
    getCategoryBrand(id) {
      return this.$store.getters.getBrands.find(brand => brand.id === id);
    }
  }
};
</script>

<style scoped>
.carousel-3d-container {
  overflow: visible !important;
}

.backLogo {
  position: relative;
  display: block;
  float: left;
  opacity: 0.1;
  background-size: contain;
  width: 350px;
  height: 350px;
  
}
.backLogoDiv {
  width: 100%;
  position: absolute;
  bottom: 0;
}

#carouselMain-img {
  height: 100% !important;
  width: 100% !important;
  background-size: cover !important;
}

#logo-img {
  margin-top: 20%;
  height: 100% !important;
  width: 100% !important;
  background-size: contain !important;
}

#playArrow {
  height: 100%;
  width: 100%;
  font-size: 10em;
  margin: auto auto;
  cursor: pointer;
  text-shadow: 6px 6px 10px rgba(0, 0, 0, 0.5);
  transition: color 0.5s ease;
}

#carMargin {
  margin-top: 5%;
}

#descriptSize {
  max-width: 55% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Category.vue